import { SxProps } from "@mui/material";
import muiVariables from "../../styles/mui-variables";

const ButtonComponentStyle = {
  buttonSx: {
    textTransform: "none",
    backgroundColor: `${muiVariables.primaryBtnColor}`,
    height: "42px",
    borderRadius: "6px",
    fontSize: muiVariables.mainHeadingFontSize,
    fontWeight: 500,
    boxShadow: "none",
    padding: "11px 40px 11px 40px",
    "&:hover": {
      backgroundColor: `${muiVariables.primaryBtnColor}`,
    },
  } as SxProps,
};

export default ButtonComponentStyle;
